import React from 'react';
import css from './GoogleMapSuggestionsInput.module.css';
import TextInput from '@shared/Ui/CustomInputs/TextInput/TextInput';
import TargetIcon from '@shared/Icons/TargetIcon';
import { SearchIcon } from '@shared/Icons/SearchIcon';

interface GoogleMapSuggestionsInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    suggestions: string[];
    onSelectSuggestion: (suggestion: string) => void;
    value: string;
    disableSuggestions?: boolean;
    showSearchIcon?: boolean;
}

const GoogleMapSuggestionsInput: React.FC<GoogleMapSuggestionsInputProps> = ({
    suggestions,
    onSelectSuggestion,
    disableSuggestions = false,
    showSearchIcon = false,
    ...props
}) => {
    const handleSelectSuggestion = (suggestion: string) => () => {
        onSelectSuggestion(suggestion);
    };

    return (
        <div className={css.autocompleteContainer}>
            <TextInput
                rightChildren={<TargetIcon />}
                leftChildren={showSearchIcon && <SearchIcon />}
                {...props}
            ></TextInput>
            {suggestions.length > 0 && !disableSuggestions && (
                <ul className={css.suggestionsList}>
                    {suggestions.map((suggestion, index) => (
                        <li
                            key={index}
                            onClick={handleSelectSuggestion(suggestion)}
                            className={css.suggestionItem}
                        >
                            {suggestion}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default GoogleMapSuggestionsInput;
